import { CollectionModel } from 'common/api/models';
import { callApi, sortingApiMap } from 'utils';
import { getI18nLng } from 'utils/i18n';

/**
 * @param {{searchTerm: {string}, pageNum: {number}, sorting: {string}}} payload
 * @return {Promise<any>}
 */
export const fetchSearchApi = ({ searchTerm, perPage, pageNum, sorting }) => {
  const language = getI18nLng();

  return callApi(
    `search?searchTerm=${encodeURIComponent(searchTerm)}${
      perPage ? `&perPage=${perPage}` : ''
    }&pageNum=${pageNum}${sortingApiMap(sorting)}&lang=${language}`
  ).then(CollectionModel);
};
